export function computeCapabilities(role) {
    switch (role) {
        case "owner":
            return {
                canEditCampaign: true,
                canDeleteCampaign: true,
                canManageJoinCode: true,
                canManageMembers: true,
                canPromoteMembers: true,
            };
        case "gm":
            return {
                canEditCampaign: true,
                canDeleteCampaign: false,
                canManageJoinCode: true,
                canManageMembers: true,
                canPromoteMembers: true,
            };
        case "player":
            return {
                canEditCampaign: false,
                canDeleteCampaign: false,
                canManageJoinCode: false,
                canManageMembers: false,
                canPromoteMembers: false,
            };
    }
}
